import ProductsService from '@services/products-service.js'
import MerchantProductsService from '@services/merchant-products-service.js'
import FilesService from '@services/files-service.js'
import _ from 'lodash'

export const state = {
    categories: [],
    products: [],
    imagesLinks: {},
}

export const mutations = {
    SET_CATEGORIES(state, { categories }) {
        state.categories = categories
    },
    SET_PRODUCTS(state, { products }) {
        state.products = products
    },
    SET_PRODUCTS_IMG_LINKS(state, imagesLinks) {
        state.imagesLinks = imagesLinks
    },
}

export const getters = {
    categories: state => state.categories,
    products: state => state.products,
    imagesLinks: state => state.imagesLinks,
    getProductById: state => productId =>
        state.products.filter(product => product._id === productId)[0],
    getCategoryById: state => categoryId =>
        state.categories.filter(category => category._id === categoryId)[0],
}

export const actions = {
    async getCategories({ commit }) {
        const categories = await ProductsService.getCategories()

        commit('SET_CATEGORIES', categories)
        return categories
    },

    async getProducts({ commit }, option) {
        const products = await MerchantProductsService.getProducts(option)
        const { imagesLinks } = await FilesService.findImages({
            imageIds: _.flatten(
                products.products.map(product => product.images)
            ).filter(item => item),
        })

        products.products = products.products.map(product => ({
            ...product,
            images: product.images
                ? product.images.map(imageId => imagesLinks[imageId])
                : [],
        }))

        commit('SET_PRODUCTS', products)
        commit('SET_PRODUCTS_IMG_LINKS', imagesLinks)
        return products
    },
}
